import {Component, inject, OnInit} from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {HeaderComponent} from "../../../common/header/header.component";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {LocaleService} from "../../../../locale/locale.service";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';
import {ClaimsService} from "../../../../services/claims.service";
import {AccidentRoleType} from "../../../../enums/accident-role-type";

@Component({
  selector: 'app-accident-role',
  imports: [
    FooterComponent,
    HeaderComponent,
    ReactiveFormsModule
  ],
  templateUrl: './accident-role.component.html',
  styleUrl: './accident-role.component.css'
})
export class AccidentRoleComponent implements OnInit {
  locale = inject(LocaleService);
  private formNavigationService = inject(FormNavigationService);
  private claimService = inject(ClaimsService);

  showError: boolean = false;
  options: { headline: string, caption: string, value: string }[] = [];
  radioControl = new FormControl();

  constructor() {
    this.options = [
      {
        headline: this.locale.currentTranslation.accidentRoleOptionHeadline1,
        caption: this.locale.currentTranslation.accidentRoleOptionCaption1,
        value: AccidentRoleType.Driver
      },
      {
        headline: this.locale.currentTranslation.accidentRoleOptionHeadline2,
        caption: this.locale.currentTranslation.accidentRoleOptionCaption2,
        value: AccidentRoleType.Passenger
      },
      {
        headline: this.locale.currentTranslation.accidentRoleOptionHeadline3,
        caption: this.locale.currentTranslation.accidentRoleOptionCaption3,
        value: AccidentRoleType.Pedestrian
      },
      {
        headline: this.locale.currentTranslation.accidentRoleOptionHeadline4,
        caption: this.locale.currentTranslation.accidentRoleOptionCaption4,
        value: AccidentRoleType.NotInvolved
      },
    ]
  }

  ngOnInit(): void {
    this.claimService.getData().subscribe(() => {
      if (this.claimService.claimReport()?.accidentRoleType) {
        this.radioControl = new FormControl(this.claimService.claimReport().accidentRoleType);
      }
    })
  }

  nextClicked() {
    this.evaluateShowError()
    if (!this.showError) {
      this.claimService.updateClaimReport({accidentRoleType: this.radioControl.getRawValue()});
      this.claimService.save().subscribe(() => {
        this.formNavigationService.navigate(NavigationKey['accident-role'], [this.radioControl.getRawValue()]);
      });
    }
  }

  private evaluateShowError() {
    let rawValue = this.radioControl.getRawValue();
    this.showError = rawValue == null;
  }

  setOption(value: string) {
    this.radioControl.patchValue(value);
    this.showError = false
  }
}
